module.exports = __webpack_public_path__ + "static/media/45.0136cc76.jpg";